var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unknown"},[_c('span',[_vm._v(_vm._s(_vm.$t('im.nonsupportMsg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }